module.exports = __webpack_public_path__ + "static/media/BMP.ceeecff9.svg";